module.exports = __webpack_public_path__ + "static/media/icon_inbox_altacontratante.ed802a0e.svg";